export const RestApiParams = Object.freeze({
    LEDGER_ITEMS_URL: process.env.REACT_APP_API_BASE_URL ? process.env.REACT_APP_API_BASE_URL + '/ledgerItems' : '',
    CATEGORIES_URL: process.env.REACT_APP_API_BASE_URL ? process.env.REACT_APP_API_BASE_URL + '/categories' : '',
    LOGIN_URL: process.env.REACT_APP_API_BASE_URL ? process.env.REACT_APP_API_BASE_URL + '/auth/login' : '',
    LOGOUT_URL: process.env.REACT_APP_API_BASE_URL ? process.env.REACT_APP_API_BASE_URL + '/auth/logout' : '',
    REFRESH_TOKEN_URL: process.env.REACT_APP_API_BASE_URL ? process.env.REACT_APP_API_BASE_URL + '/auth/refresh' : '',
});
